import { render } from "./ShrubTreePage.vue?vue&type=template&id=edb54c26&scoped=true"
import script from "./ShrubTreePage.vue?vue&type=script&lang=js"
export * from "./ShrubTreePage.vue?vue&type=script&lang=js"

import "./ShrubTreePage.vue?vue&type=style&index=0&id=edb54c26&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb54c26"]])

export default __exports__